<style lang="scss" scoped>
a[class^="share-network-"] {
	flex: none;
	color: #FFFFFF !important;
	background-color: #333;
	border-radius: 3px;
	overflow: hidden;
	display: flex;
	flex-direction: row;
	align-content: center;
	align-items: center;
	cursor: pointer;
	margin: 0 0 10px 0;

  .icon-name {
    padding: 0 10px;
    flex: 1 1;
    font-weight: 500;
  }

  .icon-wrapper {
    background-color: rgba(0, 0, 0, 0.2);
    height: 30px;
    width: 30px;
  }
}
.share-popup {
  background-color: #999;
  padding: 10px 10px 0;
  border-radius: 5px;
}
</style>
<template>
  <div class="share-popup">
    <ShareNetwork
      v-for="network in networks"
      :key="network.network"
      :network="network.network"
      :style="{backgroundColor: network.color}"
      :url="shareData.url"
      :title="shareData.title"
      :description="shareData.description"
      :quote="shareData.quote"
      :hashtags="shareData.hashtags"
      :twitter-user="shareData.twitterUser"
    >
      <span class="icon-wrapper frow centered">
        <i :class="network.icon" />
      </span>
      <span class="icon-name">{{ network.name }}</span>
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  name: 'Share',
  props: {
    shareData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      networks: [
        { network: 'facebook',
          name: 'Facebook',
          icon: 'fab fah fa-lg fa-facebook-f',
          color: '#1877f2', 
        },
        { network: 'twitter',
          name: 'Twitter',
          icon: 'fab fah fa-lg fa-twitter',
          color: '#1da1f2', 
        },
        { network: 'email',
          name: 'Email',
          icon: 'far fah fa-lg fa-envelope',
          color: '#333333', 
        },
        { network: 'whatsapp',
          name: 'Whatsapp',
          icon: 'fab fah fa-lg fa-whatsapp',
          color: '#25d366', 
        },
      ],
    };
  },
  computed: {
  },
};
</script>
<style scoped lang="scss">

</style>
